import { applyMiddleware, configureStore } from '@reduxjs/toolkit'
import thunkMiddleware from 'redux-thunk'
import navigationReducer from '../services/navigationSlice'
import loginReducer from '../services/loginSlice'
import productsReducer from '../services/productsSlice';
import topReducer from '../services/topSlice';
import plansReducer from '../services/plansSlice'
import userReducer from '../services/userSlice'


const composedEnhancer = applyMiddleware(thunkMiddleware)

const store = configureStore({
    reducer: {
        navigation: navigationReducer,
        login: loginReducer,
        products: productsReducer,
        top: topReducer,
        plans: plansReducer,
        user: userReducer
    },
    enhancers: composedEnhancer
});
export default store
